const toUiAttributesMap = {
  string: 'string',
  number: 'number',
  integer: 'int',
  boolean: 'boolean',
  enum: 'enum'
};
const toOpenApiMap = {
  int: 'integer'
};
function toUiAttributesType(type, model) {
  // if ( type === 'string' && model.enum ) {
  //   return toUiAttributesMap.enum
  // }
  return toUiAttributesMap[type] ?? type;
}
function toOpenApiType(type) {
  return toOpenApiMap[type] ?? type;
}
function getObjectType(apiName, type) {
  return `${apiName}.${type}`;
}
export { toUiAttributesType, toOpenApiType, getObjectType };
export default {
  toUiAttributesType,
  toOpenApiType,
  getObjectType
};